<template>
  <v-container>
    <module-bar title="REPORTE DE VEHICULOS" icon="mdi-car-multiple" class="d-print-none" />

    <v-row v-if="loadingData">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="1" size="60" />
      </v-col>
    </v-row>

    <v-row v-if="loadedData">
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar vehiculo" single-line hide-details
          style="max-width: 400px" class="mb-5"></v-text-field>

        <v-card outlined>
          <v-data-table :search="search" :headers="headers" :items="vehicules" :items-per-page="10"
            :mobile-breakpoint="800" @click:row="openDialog">
            <template v-slot:[`item.name`]="{ item }">
              <v-avatar size="50">
                <v-img :src="item.photo_1 ? item.photo_1 : photoEmpty" :lazy-src="item.photo_1_thumb" />
              </v-avatar>
            </template>
            
            <template v-slot:[`item.status`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon size="15" v-bind="attrs" v-on="on" :color="item.enabled ? 'green' : 'red'">mdi-circle</v-icon>
                </template>
                <span>{{
                  item.enabled ? "Activo" : "Inactivo"
                }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.assigned`]="{ item }">
              <v-chip small :text-color="item.assigned != 'No asignado' ? 'white' : 'black'"
                :color="item.assigned != 'No asignado' ? 'green' : 'default'" label> {{ item.assigned }}</v-chip>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- dialog editar vehiculo -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-card-text>
          <vehicule-form title="EDITAR VEHICULO" schema="edit" :vehicule="vehicule" :click="click"
            @closeDialogVehicule="closeDialogVehicule" @deleteVehicule="deleteVehicule"
            @desvinculeEmployee="desvinculeEmployee" @vinculeEmployee="vinculeEmployee" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import VehiculeForm from "../../components/Forms/VehiculeForm.vue";
import photoEmpty from "../../assets/profile.jpeg";

export default {
  components: { ModuleBar, VehiculeForm },

  data() {
    return {
      photoEmpty: photoEmpty,
      vehiculesAssigned: [],
      showListAssigned: true,
      showList: false,
      vehicules: [],
      loadingData: true,
      loadedData: false,
      dialog: false,
      search: "",
      click: 0,
      vehicule: null,

      headers: [
        {
          text: "Nombre",
          value: "name",
          width: "10%",
        },
        {
          text: "Status",
          value: "status",
          width: "10%",
        },
        {
          text: "Asignado",
          value: "assigned",
          width: "10%",
        },
        {
          text: "Placa",
          value: "plate",
          width: "15%",
        },
        {
          text: "Ubicacion",
          value: "location.name",
          width: "10%",
        },
        {
          text: "Distrito",
          value: "district",
          width: "20%",
        },
        {
          text: "Modelo",
          aling: "left",
          value: "model",
          width: "20%",
        },
        {
          text: "Tipo",
          aling: "center",
          value: "type",
          width: "20%",
        },
      ],
    };
  },

  beforeMount() {
    this.loadVehicules();
  },

  watch: {
    clickTo() {
      this.loadVehicules();
    },
  },

  methods: {
    openDialog(value) {
      this.vehicule = value;
      this.click++;
      this.dialog = true;
    },

    closeDialogVehicule(data) {
      if (data) {
        data.type = data.type == 'car' ? 'CARRO / CAMIONETA' : 'MOTO'
        data.category_id = parseInt(data.category_id);
        let index = this.vehicules.findIndex((v) => v.id == data.id);
        this.vehicules.splice(index, 1, data);
      }
      this.dialog = false;
    },

    deleteVehicule({ vehiculeId }) {
      this.dialog = false;
      let index = this.vehicules.findIndex((v) => v.id == vehiculeId);
      this.vehicules.splice(index, 1);
    },

    loadVehicules() {
      this.loadingData = true;
      this.loadedData = false;
      setTimeout(() => {
        this.$store.dispatch("findVehiculesAction").then((res) => {
          res.forEach(element => {
            element.type = element.type == 'car' ? 'CARRO / CAMIONETA' : 'MOTO'
          });

          this.vehicules = res;
          this.loadingData = false;
          this.loadedData = true;
        });
      }, 500);
    },

    releaseVehicule(vehicule) {
      this.vehicules.push(vehicule);
      let index = this.vehiculesAssigned.findIndex((v) => v.id == vehicule.id);

      this.vehiculesAssigned.splice(index, 1);
    },

    desvinculeEmployee({ vehiculeId }) {
      let index = this.vehicules.findIndex((v) => v.id == vehiculeId);
      if (index > -1) {
        this.vehicules[index].employee_id = 0;
      }
    },

    vinculeEmployee(data) {
      let index = this.vehicules.findIndex(
        (v) => v.id == parseInt(data.vehicule_id)
      );

      if (index > -1) {
        this.vehicules[index].employee = data.employee;
        this.vehicules[index].employee_id = data.employee.id;
      }
    },
  },
};
</script>
